import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/posts')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{ padding: '15px', background: '#e8f4f8', borderRadius: '8px', marginBottom: '20px', border: '2px solid #0066cc' }}>
        <h1 style={{ marginBottom: '10px', color: '#333' }}>Layout Route: Posts</h1>
        <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
          자식 라우트를 감싸는 레이아웃입니다. 공통 네비게이션과 스타일을 제공하며 &lt;Outlet&gt;을 통해 자식을 렌더링합니다.
        </p>
        <nav>
          <Link to="/" style={{ marginRight: '10px', color: '#0066cc' }}>← 홈으로</Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link to="/posts" style={{ marginRight: '10px', color: '#0066cc' }}>Posts Index</Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link to="/posts/123" style={{ color: '#0066cc' }}>Post 123</Link>
        </nav>
      </div>
      <div style={{ padding: '20px', background: '#f9f9f9', borderRadius: '8px', border: '2px dashed #999' }}>
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '10px' }}>↓ 자식 라우트 영역 (Outlet) ↓</div>
        <Outlet />
      </div>
    </div>
  ),
});

